var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.72559 11.718C1.72559 7.46329 1.72559 5.33594 3.04736 4.01415C4.36914 2.69238 6.49649 2.69238 10.7512 2.69238H15.264C19.5187 2.69238 21.6462 2.69238 22.9679 4.01415C24.2897 5.33594 24.2897 7.46329 24.2897 11.718V13.9744C24.2897 18.2291 24.2897 20.3566 22.9679 21.6783C21.6462 23.0001 19.5187 23.0001 15.264 23.0001H10.7512C6.49649 23.0001 4.36914 23.0001 3.04736 21.6783C1.72559 20.3566 1.72559 18.2291 1.72559 13.9744V11.718Z",
    stroke: "#F3223C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M7.36621 2.69231V1",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M18.6484 2.69231V1",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M1.72559 8.33301H24.2897",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.62305 14.538L11.3154 12.8457V17.3585",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.1357 16.2303V13.9739C14.1357 13.3508 14.6408 12.8457 15.2639 12.8457C15.8871 12.8457 16.3922 13.3508 16.3922 13.9739V16.2303C16.3922 16.8534 15.8871 17.3585 15.2639 17.3585C14.6408 17.3585 14.1357 16.8534 14.1357 16.2303Z",
    stroke: "#F3223C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.c17aa4c33da9ab015fe3082372a64256.svg";
export { ForwardRef as ReactComponent };